import { render, staticRenderFns } from "./RadioWithInfo.vue?vue&type=template&id=1db8e21e&scoped=true&"
import script from "./RadioWithInfo.vue?vue&type=script&lang=ts&"
export * from "./RadioWithInfo.vue?vue&type=script&lang=ts&"
import style0 from "./RadioWithInfo.vue?vue&type=style&index=0&id=1db8e21e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db8e21e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio})
